<template>
    <div>
        <legend>Tillagningssteg</legend>

        <div class="form-group">
            <input
                v-model="instruction"
                type="text"
                class="form-control recipe-instruction"
                name="recipe_instructions"
                placeholder="Lägg till ett tillagningssteg"
            />
            <svg v-on:click="addInstruction" class="icon add-instruction">
                <use xlink:href="#icon-plus"></use>
            </svg>
        </div>

        <ol class="added-instructions">
            <li
                class="added-instruction"
                v-for="(instruction, index) in instructions"
                :data-index="index"
                :key="index"
            >
                <recipe-instruction
                    :instruction="instruction"
                    :instructions="instructions"
                    :index="index"
                ></recipe-instruction>

                <svg v-on:click="removeInstruction(index)" class="remove-instruction">
                    <use xlink:href="#icon-minus"></use>
                </svg>
                <input type="hidden" :name="'instructions[]'" :value="instruction" />
            </li>
        </ol>
    </div>
</template>

<script>
import RecipeInstruction from './recipe-instruction.vue';

export default {
    props: {
        initialInstructions: Array
    },

    data() {
        return {
            instructions: [],
            instruction: ''
        };
    },

    mounted() {
        this.instructions = this.initialInstructions ? this.initialInstructions : [];
    },

    methods: {
        addInstruction() {
            if (this.instruction.length > 0 && this.instructions.indexOf(this.instruction) == -1) {
                this.instructions.push(this.instruction);
                this.instruction = '';
            }
        },

        removeInstruction(index) {
            this.instructions.splice(index, 1);
        }
    },
    components: {
        RecipeInstruction: RecipeInstruction
    }
};
</script>
